import React, { Fragment, useContext, useState } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import QATeamLeaderChallengeAcceptDialog from "./QATeamLeaderChallengeAcceptDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";
interface IQATeamLeaderFeedbackTabButtonsProps {
    feedback: FeedbackTabButtonsViewModel;
    getFeedback: () => void;
    setRescoreCompleteId: (completeId: number) => void;
    close: () => void;
}
export default function QATeamLeaderFeedbackTabButtons(props: IQATeamLeaderFeedbackTabButtonsProps) {
    const { get, post, loading } = useContext(APIContext);
    const [challengeAcceptDialogOpen, setChallengeAcceptDialogOpen] = useState<boolean>(false);

    const acceptFeedbackChallenge = (reason: string) => {
        if (props.feedback.deleteOnChallengeUpheld) {
            post('Feedback', `AcceptFeedbackChallengeDelete?completeId=${props.feedback.completeId}`, reason, () => {
                props.close();
            });
        }
        else {
            post('Feedback', `AcceptFeedbackChallengeRescore?completeId=${props.feedback.completeId}`, reason, (data) => {
                props.setRescoreCompleteId(data);
                props.getFeedback();
            });
        }
    }

    const rejectFeedbackChallenge = () => {
        get('Feedback', `RejectFeedbackChallenge?completeId=${props.feedback.completeId}`, () => {
            props.getFeedback();
        });
    }

    return (
        props.feedback.status === 'Feedback Challenged' ?
            <Fragment>
                <QATeamLeaderChallengeAcceptDialog
                    open={challengeAcceptDialogOpen}
                    close={() => setChallengeAcceptDialogOpen(false)}
                    acceptFeedbackChallenge={acceptFeedbackChallenge}
                    feedback={props.feedback}
                />
                {
                    !loading ?
                        <Fragment>
                            <Grid size={12}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    disabled={props.feedback.status !== 'Feedback Challenged' || loading}
                                    fullWidth
                                    onClick={() => setChallengeAcceptDialogOpen(true)}>
                                    {
                                        props.feedback.scorecardType === "Monitoring" ?
                                            <Typography variant="button">Accept feedback challenge</Typography>
                                            :
                                            <Typography variant="button">Accept challenge and delete feedback</Typography>
                                    }
                                </Button>
                            </Grid>
                            <Grid size={12}>
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    disabled={props.feedback.status !== 'Feedback Challenged' || loading}
                                    fullWidth
                                    onClick={rejectFeedbackChallenge}>
                                    Reject feedback challenge
                                </Button>
                            </Grid>
                        </Fragment>
                        :
                        <Grid container justifyContent="center" alignItems="center" marginTop={2}>
                            <Grid>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                }
            </Fragment>
            :
            <Fragment />
    );
}